module.exports = __webpack_public_path__ + "static/media/StormWatch.de901310.png";